'use client'

import { memo } from 'react'

import { ErrorDataUnavailable } from '@/components/common/Error'

const VaultV2HeroError = () => {
  return <ErrorDataUnavailable minHeight="338px" />
}

export default memo(VaultV2HeroError)
